import styled from 'styled-components';

import { BaseStyle, Button } from '@nhl/nhl-breakaway-ui';

const ACTION_HEIGHT = 110;
const Z_INDEX = 100;

export const DialogContainer = styled.div<{ $expandedFilters: boolean }>`
    background: ${({ theme }) => theme.Surface.Opposite.primary};
    height: 100vh;
    left: 0;
    opacity: ${({ $expandedFilters }) => ($expandedFilters ? 0.5 : 0)};
    position: fixed;
    top: 0;
    width: 100vw;
    transition: opacity 0.5s;
    visibility: ${({ $expandedFilters }) => ($expandedFilters ? 'initial' : 'hidden')};
    z-index: 100;
`;

export const FilterModalHeading = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 16px;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['36m']}
        cursor: pointer;
    }
`;

export const FilterActionContainer = styled.div<{ $expandedFilters: boolean }>`
    ${BaseStyle.Mixins.gaps.large};
    ${BaseStyle.Mixins.utility.boxShadow(16, 'rgba(0, 0, 0, 0.15)', [BaseStyle.StyleDirections.up])};
    align-items: center;
    background: ${({ theme }) => theme.Surface.primary};
    bottom: 0;
    display: flex;
    height: ${ACTION_HEIGHT}px;
    justify-content: center;
    margin-left: ${({ $expandedFilters }) => ($expandedFilters ? '-16px' : 0)};
    padding: 16px;
    position: fixed;
    width: inherit;

    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-left: ${({ $expandedFilters }) => ($expandedFilters ? '-32px' : 0)};
        padding: 32px;
    }
`;

export const FilterButton = styled(Button)`
    height: 48px;
`;

export const FiltersContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.large}
        margin-top: 27px;
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
    }
`;

export const SmallScreenFilters = styled.dialog<{ $expandedFilters: boolean }>`
    background: ${({ theme }) => theme.Surface.primary};
    border: none;
    display: flex;
    flex-direction: column;
    gap: ${BaseStyle.GAP_SIZES.large}px;
    height: 100vh;
    left: ${({ $expandedFilters }) => ($expandedFilters ? 0 : '100vw')};
    max-height: initial;
    max-width: initial;
    padding: 32px 16px ${ACTION_HEIGHT + 16}px 16px;
    position: fixed;
    top: 0;
    transition: left 0.5s;
    width: 100vw;
    z-index: ${Z_INDEX};
`;
